import { buildApi } from '@hourly/utilities/api';

export default buildApi(import.meta.env.VITE_API_URL);
